var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "23px",
    viewBox: "0 0 26 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Add / Filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Q2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sale->-Item->--Promotion-Selected-b",
    transform: "translate(-865.000000, -25.000000)",
    fill: "#757575",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bars-/-Top-Bar-/-Menu-Expanded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons",
    transform: "translate(718.000000, 3.960784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Promo",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Promo-Copy-2",
    transform: "translate(132.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons-/-Contained-/-Enabled-Copy-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Add-/-Filled",
    transform: "translate(15.500000, 15.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,11.5 L23.5,20.3 C23.5,21.5150264 22.5150264,22.5 21.3,22.5 L3.7,22.5 C2.48497355,22.5 1.5,21.5150264 1.5,20.3 L1.5,11.5 C0.892486775,11.5 0.4,11.0075132 0.4,10.4 L0.4,7.1 C0.4,5.88497355 1.38497355,4.9 2.6,4.9 L6.087,4.9 C5.966,4.559 5.9,4.185 5.9,3.8 C5.9,1.97746033 7.37746033,0.5 9.2,0.5 C10.3,0.5 11.268,1.05 11.873,1.864 L11.873,1.853 L12.5,2.7 L13.127,1.853 L13.127,1.864 C13.732,1.05 14.7,0.5 15.8,0.5 C17.6225397,0.5 19.1,1.97746033 19.1,3.8 C19.1,4.185 19.034,4.559 18.913,4.9 L22.4,4.9 C23.6150264,4.9 24.6,5.88497355 24.6,7.1 L24.6,10.4 C24.6,11.0075132 24.1075132,11.5 23.5,11.5 M3.7,20.3 L11.4,20.3 L11.4,11.5 L3.7,11.5 L3.7,20.3 M21.3,20.3 L21.3,11.5 L13.6,11.5 L13.6,20.3 L21.3,20.3 M9.2,2.7 C8.59248678,2.7 8.1,3.19248678 8.1,3.8 C8.1,4.40751322 8.59248678,4.9 9.2,4.9 C9.80751322,4.9 10.3,4.40751322 10.3,3.8 C10.3,3.19248678 9.80751322,2.7 9.2,2.7 M15.8,2.7 C15.1924868,2.7 14.7,3.19248678 14.7,3.8 C14.7,4.40751322 15.1924868,4.9 15.8,4.9 C16.4075132,4.9 16.9,4.40751322 16.9,3.8 C16.9,3.19248678 16.4075132,2.7 15.8,2.7 M2.6,7.1 L2.6,9.3 L11.4,9.3 L11.4,7.1 L2.6,7.1 M13.6,7.1 L13.6,9.3 L22.4,9.3 L22.4,7.1 L13.6,7.1 Z",
    id: "Shape"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard);
export default __webpack_public_path__ + "static/media/Gift-card.fc41ebda.svg";
export { ForwardRef as ReactComponent };